import { createStyles } from '@mantine/core';

export interface IconStylesParams {
  color?: string;
}

export default createStyles( ( _theme, { color }: IconStylesParams ) => ( {
	root: { color }
} ) );
